<template>
  <div class="w-100 h-100 m-0" style="padding: 32px">
    <div class="mt-0 p-0 d-flex acry-page-title justify-content-center" style="gap:8px; margin-bottom: 40px;">
      <img src="@/assets/acrypro/coupon/step2.svg" />
      <div>デザイン登録</div>
    </div>
    <div class="m-0 d-flex flex-column text-start" style="padding:32px; gap:24px; background: #F8F8F8;">
      <div class="d-flex" style="padding-bottom:32px; height:56px; gap: 64px; border-bottom: solid 1px #E0E0E0">
        <div class="acrypro-text-main-bold d-flex justify-content-between" style="width:220px;">
          <div>作成サイズ</div>
          <div class="input-required d-flex">
            <div class="m-auto">必須</div>
          </div>
        </div>
        <div class="d-flex flex-grow-1" style="gap: 30px;">
          <div class="d-flex" style="gap: 16px;">
            <input ref="inputS" class="input-radio" type="radio" id="option1" value="S" :checked="selectSize === 'S'" @change="onChange('S')"/>
            <div>S {{getSizeSPriceBase.toLocaleString("ja-JP", { style: "currency", currency: "JPY" })}}(税別)/枚</div>
          </div>
          <div class="d-flex" style="gap: 16px;">
            <input ref="inputM" class="input-radio" type="radio" id="option2" value="M" :checked="selectSize === 'M'" @change="onChange('M')"/>
            <div>M {{getSizeMPriceBase.toLocaleString("ja-JP", { style: "currency", currency: "JPY" })}}(税別)/枚</div>
          </div>
          <div class="d-flex" style="gap: 16px;">
            <input ref="inputL" class="input-radio" type="radio" id="option3" value="L" :checked="selectSize === 'L'" @change="onChange('L')"/>
            <div>L {{getSizeLPriceBase.toLocaleString("ja-JP", { style: "currency", currency: "JPY" })}}(税別)/枚</div>
          </div>
        </div>
      </div>

      <div class="d-flex" style="padding-bottom:32px; height:100px; gap: 64px; border-bottom: solid 1px #E0E0E0">
        <div class="acrypro-text-main-bold d-flex justify-content-between" style="width:220px;">
          <div>送料負担</div>
          <div class="input-required d-flex">
            <div class="m-auto">必須</div>
          </div>
        </div>
        <div class="d-flex flex-grow-1" style="gap: 42px;">
          <div class="d-flex flex-column" style="gap: 8px;">
            <div class="d-flex" style="gap: 64px;">
              <div class="d-flex" style="gap: 16px;">
                <input class="input-radio" type="radio" id="option1" :value="false" v-model="isShippingFee" />
                <div>チケット発行者負担</div>
              </div>
              <div class="d-flex" style="gap: 16px;">
                <input class="input-radio" type="radio" id="option2" :value="true" v-model="isShippingFee" />
                <div>チケット利用者負担</div>
              </div>
            </div>
            <div style="font-size: 12px;">
              <p class="m-0">● アクリルアイテムの発送料負担をチケット発行者・チケット利用者のどちらかに設定する事ができます</p>
              <p class="m-0">● 1個につき送料{{getAcryShippingFee}}円（税込）</p>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex" style="padding-bottom:32px; height:135px; gap: 64px; border-bottom: solid 1px #E0E0E0">
        <div class="acrypro-text-main-bold d-flex justify-content-between" style="width:220px;">
          <div>チケット使用者編集</div>
          <div class="input-required d-flex">
            <div class="m-auto">必須</div>
          </div>
        </div>
        <div class="d-flex flex-grow-1" style="gap: 90px;">
          <div class="d-flex flex-column" style="gap: 8px;">
            <div class="d-flex flex-column" style="gap: 8px;">
              <div class="d-flex" style="gap: 16px;">
                <input class="input-radio" type="radio" id="option1" :value="true" v-model="userEdit" />
                <div style="width: 32px;">可</div>
                <div>（チケット使用者が一部または全体を編集可能です）</div>
              </div>
              <div class="d-flex" style="gap: 16px;">
                <input class="input-radio" type="radio" id="option2" :value="false" v-model="userEdit" />
                <div style="width: 32px;">不可</div>
                <div>（登録されたデザインのまま製作されます）</div>
              </div>
            </div>
            <div style="font-size: 12px;">
              <p class="m-0">● チケット使用者によるデザイン編集の可否を設定します。</p>
              <p class="m-0">● <span class="c-pointer" style="text-decoration: underline; color: #8C9BC6;" @click="setPRModal(true)">チケット使用者編集について</span></p>
            </div>
          </div>

        </div>
      </div>

      <div class="d-flex" style="padding-bottom:32px; height:410px; gap: 48px;">
        <div class="acrypro-text-main-bold d-flex justify-content-between" style="width:220px;">
          <div>アクリルデザイン</div>
          <div class="input-required d-flex">
            <div class="m-auto">必須</div>
          </div>
        </div>
        <div class="d-flex flex-column" style="gap: 8px;">
          <div class="c-pointer" style="height: 320px; width: 200px;" @click="onClickDesignUpload">
            <img v-if="this.$store.state.eventCreateData.previewData" class="w-100 h-100" style="object-fit: contain; dashed 1px #D1D5DB; background: #FFFFFF;" :src="this.$store.state.eventCreateData.previewData.fileURL" />
            <img v-if="!this.$store.state.eventCreateData.previewData" class="w-100 h-100" style="object-fit: contain;" src="@/assets/acrypro/coupon/upload_design.svg" />
          </div>
          <div class="m-0" style="height: 40px; font-size: 12px;">
            <p class="m-0">●デザイン作成の詳しい方法は<span class="c-pointer" style="text-decoration: underline; color: #8C9BC6;" @click="onClickHelp()">ご利用ガイド</span>を参考にしてください。</p>
          </div>
        </div>
      </div>

    </div>

    <div class="d-flex justify-content-center" style="gap:32px;">
      <button class="mx-0 acry-btn-sub fw-bold" style="width: 240px; height: 54px; border-radius: 100px; font-size: 16px; margin-top:40px;" @click="clickReturnBtn">
        もどる
      </button>
      <button class="mx-0 acry-btn fw-bold" style="width: 240px; height: 54px; border-radius: 100px; font-size: 16px; margin-top:40px;" @click="clickConfirmBtn">
        確定
      </button>
    </div>

    <!-- PR説明モーダル -->
    <div v-if="isPRModal" class="modal-bg" @click="setPRModal(false)">
      <div class="d-flex flex-column justify-content-center align-items-center position-relative" style="width: 1200px; height: 800px; border-radius: 8px; background: #FEFEFE; padding: 40px 0px; gap: 24px;" v-on:click.stop="">
        <img class="position-absolute c-pointer" style="top: 40px; right: 40px;" src="@/assets/acrypro/close.svg" @click="setPRModal(false)">
        <div class="fw-bold" style="font-size: 28px;">
          チケット使用者編集について
        </div>
        <div class="text-start" style="font-size: 14px;">
          <p class="m-0">アクリルデザインを登録時に、チケット使用者編集を可能にするか設定することができます。</p>
          <p class="m-0">ロゴやブランド名など変更されたくない要素を固定しつつ、ブランドイメージを守りながらユーザー体験を向上させることができます。</p>
        </div>
        <div class="d-flex text-start" style="gap: 16px;">
          <img src="@/assets/acrypro/coupon/ticket_ex1.svg" style="width: 179px; height: 253px;"/>
          <img src="@/assets/acrypro/coupon/ticket_ex2.svg" style="width: 179px; height: 253px;"/>
          <div class="d-flex flex-column" style="gap: 8px; width: 666px;">
            <div class="d-flex" style="background: #F5F7FA; height: 36px;">
              <div class="my-auto" style="padding: 8px; font-size: 15px;">チケット使用者編集・可</div>
            </div>
            <div>
              <p class="m-0">ACRY TICKETで登録したデザインを元に、ACRYアプリでチケット使用者は自由にカスタマイズが可能となります。</p>
              <p class="m-0">例えば、ロゴやビジュアルが描かれたアクリルデザインを元に、チケット使用者が名前・写真・コメントなどを入れて“自分だけの特別な一枚”が作れるようになります。</p>
              <p class="m-0">登録されたデザインは保護されるので、デザインが崩れることはありません。</p>
            </div>
            <img src="@/assets/acrypro/coupon/ticket_text1.svg" style="width: 317px; height: 20px;"/>
          </div>
        </div>
        <div class="d-flex text-start" style="gap: 16px;">
          <img src="@/assets/acrypro/coupon/ticket_ex3.svg" style="width: 179px; height: 253px;"/>
          <img src="@/assets/acrypro/coupon/ticket_ex4.svg" style="width: 179px; height: 253px;"/>
          <div class="d-flex flex-column" style="gap: 8px; width: 666px;">
            <div class="d-flex" style="background: #F5F7FA; height: 36px;">
              <div class="my-auto" style="padding: 8px; font-size: 15px;">チケット使用者編集・不可</div>
            </div>
            <div>
              <p class="m-0">チケット使用者編集ができません。</p>
              <p class="m-0">登録したデザインのまま注文されます。</p>
              <p class="m-0">ACRY TICKET（チケットコード）を持っている人だけが入手できる特別仕様や、イベント配布やキャンペーンなど、レアな体験価値を提供します。</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- PR説明モーダル -->
    <div v-if="isCreateModal" class="modal-bg">
      <div class="d-flex flex-column justify-content-center align-items-center position-relative" style="width: 1200px; height: 800px; border-radius: 8px; background: #FEFEFE; padding: 40px 0px; gap: 24px;" v-on:click.stop="">
        <div class="fw-bold" style="font-size: 28px;">
          チケット種類
        </div>
      <button class="mx-0 acry-btn fw-bold" style="width: 240px; height: 54px; border-radius: 100px; font-size: 16px; margin-top:40px;" @click="onClickDesignDetail">
        詳細に戻る
      </button>
      <button class="mx-0 acry-btn fw-bold" style="width: 240px; height: 54px; border-radius: 100px; font-size: 16px; margin-top:40px;" @click="onClickCreateBtn(true)">
        サンプル作成
      </button>
      <button class="mx-0 acry-btn fw-bold" style="width: 240px; height: 54px; border-radius: 100px; font-size: 16px; margin-top:40px;" @click="onClickCreateBtn(false)">
        通常作成
      </button>
      </div>
    </div>
  </div>
</template>

<script>
import { CenterViewState, GetAcryTicketProductId, GetAcryProTicketProductId, GetAcryProductPrice, ProductId, AcryShippingFee, PreviewColorList } from "@/js/Const.js";
import { FirebaseCommon } from "@/js/FirebaseCommon.js";
import { GenerateUUID, ConvertSvgToPng, CreateFrameCutlineImage, ReplacePngColor } from "@/js/CommonFunc.js";
import { Analytics } from "@/js/Analytics.js";

export default {
  name: "CenterViewEventCreateDesign_Ap",
  props: {},
  data: function () {
    return {
      selectSize:"S",
      isShippingFee:false,
      userEdit: true,
      isPRModal: false,
      isCreateModal: false,
    };
  },
  computed: {
    getSizeSPriceBase(){
      return GetAcryProductPrice(ProductId.S_ACRYLIC_COUPON).priceBase;
    },
    getSizeMPriceBase(){
      return GetAcryProductPrice(ProductId.M_ACRYLIC_COUPON).priceBase;
    },
    getSizeLPriceBase(){
      return GetAcryProductPrice(ProductId.L_ACRYLIC_COUPON).priceBase;
    },
    getAcryShippingFee(){
      return AcryShippingFee;
    },
  },
  watch:{
    // "selectSize"(){
    //   if( this.$store.state.eventCreateData.selectSize != this.selectSize ){
    //     if( window.confirm("サイズを変更するとデザインがリセットされます\n変更しても良いですか？") ){
    //       this.$store.commit("setEventCreateEventSelectSize", this.selectSize);
    //     }else{
    //       this.selectSize = this.$store.state.eventCreateData.selectSize;
    //     }
    //     console.log(this.selectSize);
    //     console.log(this.$store.state.eventCreateData.selectSize);
    //   }
    // },
    // "selectSize": {
    //   handler(newVal, oldVal){
    //     if( this.$store.state.eventCreateData.selectSize != this.selectSize ){
    //       if( window.confirm("") ){
    //         this.$store.commit("setEventCreateEventSelectSize", this.selectSize);
    //       }else{
    //         this.selectSize = oldVal;
    //       }
    //     }
    //   },
    //   deep: true,
    // },

    "isShippingFee"(){
      this.$store.commit("setEventCreateEventIsShippingFee", this.isShippingFee);
    },
    "userEdit"(){
      this.$store.commit("setEventCreateEventUserEdit", this.userEdit);
    },
  },
  async created() {
    this.$store.state.centerViewRef.scrollTop = 0;
    this.$store.commit("hideRightMenu");
    this.$store.commit("showLoading");

    // 初期データを設定
    this.selectSize = this.$store.state.eventCreateData.selectSize;
    this.isShippingFee = this.$store.state.eventCreateData.isShippingFee;
    this.userEdit = this.$store.state.eventCreateData.userEdit;

    this.$nextTick(() => {
      switch(this.selectSize){
        case 'S':
          this.$refs.inputS.checked = true;
          this.$refs.inputM.checked = false;
          this.$refs.inputL.checked = false;
          break;
        case 'M':
          this.$refs.inputS.checked = false;
          this.$refs.inputM.checked = true;
          this.$refs.inputL.checked = false;
          break;
        case 'L':
          this.$refs.inputS.checked = false;
          this.$refs.inputM.checked = false;
          this.$refs.inputL.checked = true;
          break;
      }
    })

    this.$store.commit("hideLoading");
  },
  components: {
    
  },
  methods: {
    setPRModal(isModal){
      this.isPRModal = isModal;
    },
    setCreateModal(isModal){
      this.isCreateModal = isModal;
    },
    async onChange(value){
      // 変更を検知
      if( value != this.selectSize ){
        // デザインが設定されているかチェック
        if( this.$store.state.eventCreateData.designData == null &&
            this.$store.state.eventCreateData.cutlineData == null &&
            this.$store.state.eventCreateData.nonEditableData == null ){
          // 登録されていない場合は即変更
          this.selectSize = value;
          this.$store.commit("setEventCreateEventSelectSize", this.selectSize);
        }else{
          if( window.confirm("サイズを変更するとデザインがリセットされます\n変更してもよろしいですか？") ){
            this.selectSize = value;
            this.$store.commit("setEventCreateEventSelectSize", this.selectSize);
            this.$store.state.eventCreateData.designData = null;
            this.$store.state.eventCreateData.cutlineData = null;
            this.$store.state.eventCreateData.nonEditableData = null;
            this.$store.state.eventCreateData.previewData = null;
          }else{
            // キャンセル処理
            switch(this.selectSize){
              case 'S':
                this.$refs.inputM.checked = false;
                this.$refs.inputL.checked = false;
                break;
              case 'M':
                this.$refs.inputS.checked = false;
                this.$refs.inputL.checked = false;
                break;
              case 'L':
                this.$refs.inputS.checked = false;
                this.$refs.inputM.checked = false;
                break;
            }
          }
        }
      }
    },


    onClickHelp(){
      window.open('https://www.acry.jp/datacreationguide');
    },
    async onClickDesignUpload(){
      // プレビュー機能初期化
      this.$store.commit("resetDesignPreviewData");
      if( this.$store.state.eventCreateData.designData ){
        this.$store.commit("setDesignPreviewData", { key: 'designImageURL', value: this.$store.state.eventCreateData.designData.fileURL});
      }
      if( this.$store.state.eventCreateData.cutlineData ){
        const TicketProductId = GetAcryProTicketProductId(
          this.$store.state.eventCreateData.isShippingFee,
          this.$store.state.eventCreateData.selectSize,
          false
        );

        // SVGをPNGに変換
        let fileUrl = await ConvertSvgToPng(this.$store.state.eventCreateData.cutlineData.fileURL, TicketProductId);

        // 線状のもの
        const blob = await CreateFrameCutlineImage(fileUrl);
        this.$store.commit("setEventCreateCutlineImageURL", await ReplacePngColor(URL.createObjectURL(blob), "#000000")); // この画像を使用してプレビュー用画像を作る

        // svgの色を変更
        const Color = PreviewColorList[this.$store.state.designPreview.selectCutlineColor];
        fileUrl = await ReplacePngColor(fileUrl, Color);
        this.$store.commit("setDesignPreviewData", { key: 'originalCutlineImageURL', value: fileUrl});
        fileUrl = await ReplacePngColor(URL.createObjectURL(blob), Color);
        this.$store.commit("setDesignPreviewData", { key: 'cutlineContourImageURL', value: fileUrl});
      }

      this.$store.commit("setCenterViewState", CenterViewState.EventDesignUpload);
      this.$store.commit("hideRightMenu");
      // this.$store.commit('setRightViewState', RightViewState.EventImageUpload);
    },
    onClickDesignDetail(){
      this.$store.commit("setCenterViewState", CenterViewState.EventEdit);
    },
    async clickReturnBtn(){
      // this.$store.commit("showLoading");
      // await this.saveData(false);
      // this.$store.commit("hideLoading");
      this.$store.commit("setCenterViewState", CenterViewState.EventCreate);
    },
    async clickConfirmBtn(){
      // データチェック
      if(!this.$store.state.eventCreateData.designData){
        this.$store.commit("showMessage", "デザインをアップロードしてください");
        return;
      }

      if(!this.$store.state.eventCreateData.cutlineData){
        this.$store.commit("showMessage", "デザインをアップロードしてください");
        return;
      }

      this.$store.commit("showLoading");

      await this.saveData(true);

      Analytics.acryTicketStep2Completed();

      this.$store.state.acrylicTicketCouponManager.resetOrderData();

      // 新規でドキュメントを追加した場合はドキュメントIDを設定する
      if( !this.$store.state.eventCreateData.docId ){
        const SettingId = this.$store.state.acrylicTicketCouponManager.lastAddDocumentId;
        this.$store.state.acrylicTicketCouponManager.lastAddDocumentId = "";
        this.$store.state.eventCreateData.docId = SettingId;
        this.$store.state.acrylicTicketCouponManager.orderData.acrylicTicketSettingDocId = SettingId;
        this.$store.state.acrylicTicketCouponManager.orderData.isShippingFee = this.$store.state.eventCreateData.isShippingFee;
        this.$store.state.acrylicTicketCouponManager.orderData.isUserEdit = this.$store.state.eventCreateData.userEdit;

        // 購入後の遷移のために表示用のデータを設定しておく
        this.$store.state.acrylicTicketCouponManager.setEventData(SettingId);
      }

      this.$store.commit("hideLoading");

      // モーダル表示
      // this.setCreateModal(true);

      this.onClickCreateBtn(false);
      // this.$store.commit("setCenterViewState", CenterViewState.EventTicketIssue);
    },
    async saveData(configured = false){

      if( !this.$store.state.eventCreateData.folderName ){
        this.$store.commit("setEventCreateEventFolderName", GenerateUUID());
      }
      const folderName = this.$store.state.eventCreateData.folderName;

      let designUrl = "";
      if( this.$store.state.eventCreateData.designData ){
        this.$store.state.eventCreateData.designData.rename();
        designUrl = await FirebaseCommon.uploadFile(
          this.$store.state.eventCreateData.designData.file,
          FirebaseCommon.getAcrylicTicketSettingBaseFilePath()+folderName+"/"+this.$store.state.eventCreateData.designData.fileName);
      }

      let cutlineUrl = "";
      if( this.$store.state.eventCreateData.cutlineData ){
        this.$store.state.eventCreateData.cutlineData.rename();
        cutlineUrl = await FirebaseCommon.uploadFile(
          this.$store.state.eventCreateData.cutlineData.file,
          FirebaseCommon.getAcrylicTicketSettingBaseFilePath()+folderName+"/"+this.$store.state.eventCreateData.cutlineData.fileName);
      }

      let nonEditableUrl = "";
      if( this.$store.state.eventCreateData.nonEditableData ){
        this.$store.state.eventCreateData.nonEditableData.rename();
        nonEditableUrl = await FirebaseCommon.uploadFile(
          this.$store.state.eventCreateData.nonEditableData.file,
          FirebaseCommon.getAcrylicTicketSettingBaseFilePath()+folderName+"/"+this.$store.state.eventCreateData.nonEditableData.fileName);
      }

      let previewUrl = null;
      if( this.$store.state.eventCreateData.previewData ){
        this.$store.state.eventCreateData.previewData.rename();
        previewUrl = await FirebaseCommon.uploadFile(
          this.$store.state.eventCreateData.previewData.file,
          FirebaseCommon.getAcrylicTicketSettingBaseFilePath()+folderName+"/"+this.$store.state.eventCreateData.previewData.fileName);
      }

      // プロダクトIDの登録
      // let productId = 0;
      // let ticketProductId = 0;

      // ACRY PRO側のプロダクトID
      const AcryProTicketProductId = GetAcryProTicketProductId(
        this.$store.state.eventCreateData.isShippingFee,
        this.$store.state.eventCreateData.selectSize,
        false
      );
      const AcryProSampleTicketProductId = GetAcryProTicketProductId(
        this.$store.state.eventCreateData.isShippingFee,
        this.$store.state.eventCreateData.selectSize,
        true
      );

      // ACRY側のプロダクトID
      const AcryTicketProductId = GetAcryTicketProductId(
        this.$store.state.eventCreateData.isShippingFee,
        this.$store.state.eventCreateData.selectSize,
        false
      );
      const AcrySampleTicketProductId = GetAcryTicketProductId(
        this.$store.state.eventCreateData.isShippingFee,
        this.$store.state.eventCreateData.selectSize,
        true
      );

      let data = {
        docId:this.$store.state.eventCreateData.docId,
        size:this.$store.state.eventCreateData.selectSize,
        name: this.$store.state.eventCreateData.eventName,
        issuerName:this.$store.state.eventCreateData.eventIssuerName,
        productId:AcryTicketProductId,
        ticketProductId:AcryProTicketProductId,
        sampleProductId:AcrySampleTicketProductId,
        sampleTicketProductId:AcryProSampleTicketProductId,
        folderName:this.$store.state.eventCreateData.folderName,
        design:designUrl,
        cutline:cutlineUrl,
        preview:previewUrl,
        nonEditable:nonEditableUrl,
        isUserEdit:this.$store.state.eventCreateData.userEdit,
        isShippingFee:this.$store.state.eventCreateData.isShippingFee,
        configured: configured, // 一旦完成
      };

      // PR画像は任意
      if(this.$store.state.eventCreateData.bannerData1){
        this.$store.state.eventCreateData.bannerData1.rename();
        const bannerUrl = await FirebaseCommon.uploadFile(
          this.$store.state.eventCreateData.bannerData1.file,
          FirebaseCommon.getAcrylicTicketSettingBaseFilePath()+folderName+"/"+this.$store.state.eventCreateData.bannerData1.fileName);
        data.banner1 = bannerUrl;
      }

      if(this.$store.state.eventCreateData.bannerData2){
        this.$store.state.eventCreateData.bannerData2.rename();
        const bannerUrl = await FirebaseCommon.uploadFile(
          this.$store.state.eventCreateData.bannerData2.file,
          FirebaseCommon.getAcrylicTicketSettingBaseFilePath()+folderName+"/"+this.$store.state.eventCreateData.bannerData2.fileName);
        data.banner2 = bannerUrl;
      }


      await this.$store.state.acrylicTicketCouponManager.saveEventData(data).catch(() => {
        console.log("エラー");
      });
    },
    async onClickCreateBtn(isSample){

      const TicketProductId = GetAcryProTicketProductId(
        this.$store.state.eventCreateData.isShippingFee,
        this.$store.state.eventCreateData.selectSize,
        isSample
      );
      this.$store.state.acrylicTicketCouponManager.orderData.ticketProductId = TicketProductId;
      this.$store.state.acrylicTicketCouponManager.orderData.isSample = isSample;
      this.$store.commit("setCenterViewState", CenterViewState.EventTicketIssue);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.input-required{
  width: 48px;
  height: 24px;
  background: $status-error-color;
  border-radius: 4px;
  color: #FFFFFF;
  font-size: 13px;
}

.input-radio{
  width: 24px;
  height: 24px;
  accent-color: #8593bc;
}

.acry-btn-sub {
  // margin: 10px;
  padding: 3px 30px;
  color: $primary-main-color;
  background-color: #ffffff;
  border: solid 2px $border-main-color;
  border-radius: 15px;
  font-size: 15px;
}

.uploadlabel {
  margin: 8px;
  padding: 6px;
  cursor: pointer;
  font-size: 15px;
  width: 267px;
  height: 40px;
  color: $primary-main-color;
  border: 2px solid $primary-main-color;
  border-radius: 100px;
  background: $background-white-color;
}

input[type="file"] {
  display: none;
}

</style>


